import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from '@zambezi/sdk/common'
import moment from './moment'
import { FORMAT } from './utils'

/**
 * Create a React Day Calendar Day component
 *
 * @param {import('./interfaces').DayCalendarDayProps} props
 * @returns {JSX.Element}
 */
export default function DayCalendarDay (props) {
  const {
    firstDayOfMonth,
    lastDayOfMonth,
    offset,
    isDisabled,
    isSelected,
    focusedDay,
    currentDay,
    idPrefix
  } = props
  const momentDate = moment(firstDayOfMonth).add(offset, 'days')
  const date = momentDate.toDate()
  const disabled = isDisabled(date)
  const label = momentDate.format(FORMAT)

  return (
    <td
      className={classNames({
        'is-outside-current-month':
          offset < 0 || offset >= moment(lastDayOfMonth).date(),
        'is-selected': isSelected(date),
        'is-disabled': disabled,
        'is-today': momentDate.isSame(currentDay, 'day')
      })}
      id={`${idPrefix}-${label}`}
    >
      <button
        type='button'
        className={classNames('pika-button pika-day zb-month-calendar-month', {
          'zb-date-picker-day-is-focused': momentDate.isSame(focusedDay, 'day')
        })}
        disabled={disabled}
        onClick={handleClick}
        aria-label={label}
        aria-selected={isSelected(date)}
      >
        {momentDate.date()}
      </button>
    </td>
  )

  function handleClick () {
    props.onClick(date)
  }
}

const dateProp = PropTypes.instanceOf(Date)

DayCalendarDay.propTypes = {
  firstDayOfMonth: PropTypes.number.isRequired,
  lastDayOfMonth: PropTypes.number.isRequired,
  offset: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.func.isRequired,
  isDisabled: PropTypes.func.isRequired,
  focusedDay: dateProp,
  currentDay: dateProp,
  idPrefix: PropTypes.string
}
